import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { portalMonitor } from '@/api/portalMonitor';
import { portalEventAtom } from '@/state/api/portalMonitorAtoms';
import type { Unsubscribe } from '@/types/common';
import type { PortalEvent } from '@/types/portal';
import type { Store } from '@/types/store';

type PortalSource = (listener: (event: PortalEvent) => void) => Unsubscribe;

function subscribePortal(listener: (event: PortalEvent) => void): Unsubscribe {
    return portalMonitor.subscribe(listener);
}

/**
 * Feeds the portal monitor into `store`'s atoms for as long as the calling component is
 * mounted. `subscribe` is the page's monitor unless a test hands in its own.
 */
export function usePortalMonitorBridge(
    store: Store, subscribe: PortalSource = subscribePortal,
): void {
    const send = useSetAtom(portalEventAtom, { store });
    useEffect(() => subscribe(send), [subscribe, send]);
}
